export default "__VITE_ASSET__C5wWVPAl__"